import { dataConditionType } from "types/DetailPageTypes";

export function isArrayOfConditions(
    dataCondition: dataConditionType | undefined
): dataCondition is Array<{ [key: string]: any }> {
    return Array.isArray(dataCondition);
}